import React, { useMemo } from "react";
// import "./TabAMonthWithColFilter.css";
import "./TabBMonth.css";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
} from "react-table";
//import TableData from "./TabAprildata.json";
import { COLUMNS } from "../Columns";
import {
  Container,
  Row,
  Col,
  InputGroup,
  FormControl,
  Form,
} from "react-bootstrap";
import { FaSearch } from "react-icons/fa";

function TabAprilMonth(props) {
  // useMemo Hook for unnecessary rendering of table
  const columns = useMemo(() => COLUMNS, []);
  console.log("props", props.response)
  const data = props.response;
  // react-table library essential to create an instance of the table
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
    // useSortBy
  );

  const {
    getTableProps,
    setPageSize,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
  } = tableInstance;

  // Global Filter from 'react-table'
  const { globalFilter } = state;

  // Page Index from 'react-table'
  const { pageIndex, pageSize } = state;
  const noData = data.length === 0;
  return (
    <>
      {/* Heading */}
      <div className="heading__month">
        <h5 className="heading__month_title">
          LKM Learning Calendar
        </h5>
      </div>

      {/* Global filtering and Download-Excel Button */}
      <Container fluid>
        <div className="continer__width">
          <Row>
            <Col md={6}>
              <InputGroup className="mb-3">
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <FormControl
                  value={globalFilter || ""}
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  placeholder="Search..."
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  disabled={noData}
                />
              </InputGroup>
              {/* <Form.Label>
              Search includes all columns. To get optimum result enter full
              names and dates.
            </Form.Label> */}
            </Col>
            <Col md={{ span: 2, offset: 2 }}>
              <a
                href="images/LearningCalendar/Lateral Training Calendar-Apr'22.xlsx"
                style={{ textDecoration: "none" }}
              >
                <button type="button" className="download__button" disabled={noData}>
                  Download Excel
                </button>
              </a>
            </Col>
          </Row>
        </div>
      </Container>

      {/* Table */}
      <table {...getTableProps()} className="mytable">
        <thead className="thead-dark">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps}>
          {noData ? <tr><td colSpan={14}>No data to display !</td></tr> : page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Pagination buttons */}
      <div className="pagination__button">
        <select
          className="page__size__dropdown"
          value={pageSize}
          disabled={noData}
          onChange={(e) => setPageSize(Number(e.target.value))}
        >
          {[10, 25, 50, 75, 100, 150].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
        <span>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        <button
          className="previous__button"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          {" "}
          {"<<"}Previous
        </button>
        <button
          className="next__button"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          Next{">>"}
        </button>
      </div>
    </>
  );
}

export default TabAprilMonth;
